'use strict';

/**
 * Generates a Google reCaptcha token that expires after 2mins, then attempts to verify the submission with an internal service call.
 * @return {[Promise]} [description]
 */
export function executeVerification() {
    if (window.grecaptcha) {
        return window.grecaptcha.execute(window.SFRA.SitePreferences.googleRecaptchaSiteKey, {action: 'submit'}).then(verificationCallback);
    }
}

/**
 * Make an internal call to the ReCaptcha controller and service to get back the score from Google.
 * @param  {[type]} token [description]
 * @return {[type]}       [description]
 */
export function verificationCallback(token) {
    var forms = document.querySelectorAll('form');

    // Create hidden input field in the form with Google Recaptcha Token
    forms.forEach(function(form) {
        var oldInput = form.querySelector('[name="gRecaptchaToken"]'),
            node = oldInput || document.createElement('INPUT');

        node.setAttribute('name', 'gRecaptchaToken');
        node.setAttribute('type', 'hidden');
        node.value = token;

        !oldInput && form.appendChild(node);
    });

    return {
        token: token
    };
}
